// Shared permission helpers. Client-side only — server must re-check.

const normaliseMenuConfig = (rawConfig: any): any[] => {
  let menuConfig = rawConfig?.menuConfigArray ?? rawConfig;
  if (typeof menuConfig === 'string') {
    try {
      menuConfig = JSON.parse(menuConfig);
    } catch {
      return [];
    }
  }
  return Array.isArray(menuConfig) ? menuConfig : [];
};

// True when the user's menuConfig has Legal with edit=1 or view=1.
export const hasLegalAccountReportPermission = (rawConfig: any): boolean => {
  const menuConfig = normaliseMenuConfig(rawConfig);
  return menuConfig.some(
    (app: any) =>
      app?.appComponentName === 'Legal' && (app?.edit === 1 || app?.view === 1)
  );
};
